import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const ArrowDiagonalLeftBottom = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("polygon", { fillRule: "evenodd", transform: "translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) ", points: "20 11 7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13" })));
};
export default ArrowDiagonalLeftBottom;
